interface InputProps {
    className?: string;
    unit?: string;
    unitPadding?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: boolean;
    type?: string;
    maxLength?: number;
    [key: string]: any;
}

const Input = ({
    className,
    unit,
    unitPadding,
    value,
    onChange,
    placeholder,
    onClick,
    disabled,
    onFocus,
    error = false,
    type,
    maxLength,
    ...rest
}: InputProps) => {
    return (
        <div onClick={onClick} className={`relative flex items-center ${className}`}>
            <input
                maxLength={maxLength}
                type={type}
                disabled={disabled}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onFocus={onFocus}
                className={`
                    h-[52px] w-full border rounded-lg text-[18px] px-4 outline-0
                    ${unit ? `text-right ${unitPadding}` : ""}
                    ${error ? "border-red-500 border-2" : "border-[#E1E2E4]"}
                    focus:border-2 focus:border-new
                `}
                {...rest}
            />
            {unit && (
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[18px] text-[#333] pointer-events-none bg-white">
                    {unit}
                </span>
            )}
        </div>
    );
};

export default Input;
